import * as React from "react";
import sfetch from "./commons/utils/super-fetch";
import { renderMultilineText } from "./commons/utils/text-rendering";
import ModalDelete from "./commons/components/modal/ModalDelete";
import { createRoot } from "react-dom/client";

interface TroubleshootCancelButtonProps {
  cancelEndpoint: string;
}

interface TroubleshootCancelButtonState {
  displayCancelModal: boolean;
}

export default class TroubleshootCancelButton extends React.Component<
  TroubleshootCancelButtonProps,
  TroubleshootCancelButtonState
> {
  constructor(props: TroubleshootCancelButtonProps) {
    super(props);

    this.state = {
      displayCancelModal: false,
    };
  }

  render() {
    return (
      <>
        <a
          className="button-secondary small danger"
          id="cancel-button"
          onClick={() => this.setState({ displayCancelModal: true })}
        >
          <span>{i18n["Page.Reports.Troubleshoot.Action.CancelReport"]}</span>
        </a>
        {this.state.displayCancelModal && (
          <ModalDelete
            title={i18n["Page.Reports.Troubleshoot.CancelReportConfirmation.Title"]}
            cancel={() => this.setState({ displayCancelModal: false })}
            action={() =>
              this.cancelReport().then(() => this.setState({ displayCancelModal: false }))
            }
          >
            {renderMultilineText(
              i18n["Page.Reports.Troubleshoot.CancelReportConfirmation.Description"]
            )}
          </ModalDelete>
        )}
      </>
    );
  }

  private cancelReport() {
    return sfetch(this.props.cancelEndpoint, {
      method: "DELETE",
    }).then(() => (document.location.href = "/reports/"));
  }

  static loadComponent(elementId: string, props: TroubleshootCancelButtonProps) {
    const container = document.getElementById(elementId);
    const root = createRoot(container!);
    root.render(<TroubleshootCancelButton {...props} />);
  }
}
